// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 979) return "static/chunks/979-5ca063e373520dde.js";
	if (chunkId === 614) return "static/chunks/614-6384a7a4d8afca9d.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"146":"datadog_browser_logs","340":"layout__client_site_chrome_ui","367":"layout__minimal","748":"datadog_browser_rum"}[chunkId] || chunkId) + "." + {"146":"469fb8b0eafb61b3","205":"2e90144ef4045da8","319":"0cbc2894a3f1b950","340":"751e824faace98ba","367":"9ab50f572bb27e73","639":"6f30bd92b2c07e9c","748":"a3aa8363649721ab"}[chunkId] + ".js";
};